import { Invoiceable, InvoiceLine, Party, Invoice, Budget, DeliveryNote, Proforma } from "@/modules/facturae/domain/Invoiceable";
import { InvoiceEditorScreenData } from "@/modules/facturae/domain/InvoiceEditorScreenData";
import { Product, ProductConfiguration } from "../domain/Product";
import { Configuration } from "../domain/Configuration";
import { Sequence } from "../domain/Sequence";
import { PAYMENT_MEANS_OPTIONS } from "@/modules/facturae/domain/Invoiceable";

export class VueInvoiceEditorScreenData implements InvoiceEditorScreenData{
    invoice: Invoice|Budget|DeliveryNote|Proforma
    companydb_id: number
    rectificative_invoice: Invoiceable
    excel_pop_up: boolean
    delete_all_lines_pop_up: boolean
    supplier_pop_up: boolean;
    customer_pop_up: boolean;
    file: File
    loading: boolean
    resolve_pop_up: Function 
    error_upload_file: boolean
    snackbar: Object
    reject_dialog: boolean
    reject_comment: string
    loading_reject: boolean
    paid_dialog: boolean;
    paid_loading: boolean;
    customers: Party[];
    products: Product[];
    showErrors: boolean;
    showErrorsDialog: boolean;
    showErrorsDialogVerifactu: boolean;
    configuration: Configuration;
    asyncJobState: string;
    asyncJobId: number;
    action: string;
    download_type: string;
    download_options: Object[];
    downloadPopup: boolean;
    download_loading: boolean;
    send_dialog: boolean;
    send_loading: boolean;
    senderOption: string;
    emailForm: Object;
    selectedSequence: Sequence;
    availableSequences: Sequence[];
    payment_options: Object[];
    confirmSignDialog: boolean;
    invoiceableIdList: Array<number>;
    has_prev_draft_invoices: boolean;
    showErrorExcelDialog: boolean;
    error_excel_message: string;
    showErrorSendDialog: boolean;
    error_send_message: string;
    product_configuration: ProductConfiguration;
    showRefreshDialog: boolean;
    refresh_message: string;
    hasActiveContract: boolean;

    constructor(){
        this.invoice = null
        this.rectificative_invoice = null
        this.excel_pop_up = false
        this.delete_all_lines_pop_up = false
        this.supplier_pop_up = false
        this.customer_pop_up = false
        this.loading = false
        this.file = null
        this.error_upload_file = null
        this.resolve_pop_up = null
        this.snackbar = {
            ['isVisible']: false,
            text: '',
            color: '',
            timeout: 3000,
          }
        this.reject_dialog = false
        this.reject_comment = ''
        this.loading_reject = false
        this.paid_dialog = false
        this.paid_loading = false
        this.customers = []
        this.products = []
        this.showErrors = false
        this.showErrorsDialog = false
        this.showErrorsDialogVerifactu = false
        this.configuration = new Configuration()
        this.asyncJobState = 'done';
        this.asyncJobId = 0;
        this.action = '';
        this.download_type = ''
        this.download_options = [
            {value: 'xml', text: 'XML'},
            {value: 'pdf', text: 'PDF'},
        ]
        this.downloadPopup = false
        this.download_loading = false;
        this.send_dialog = false;
        this.send_loading = false;
        this.senderOption = '';
        this.emailForm = {
            to: '',
            subject: '',
            body: ''
        }
        this.selectedSequence = new Sequence()
        this.availableSequences = []
        this.payment_options =  PAYMENT_MEANS_OPTIONS
        this.confirmSignDialog = false
        this.invoiceableIdList = []
        this.has_prev_draft_invoices = false
        this.showErrorExcelDialog = false
        this.error_excel_message = 'Ha ocurrido un error inesperado al procesar el archivo. Por favor, inténtelo de nuevo. Si el problema persiste, contacte con soporte.'
        this.showErrorSendDialog = false
        this.error_send_message = 'Ha ocurrido un error inesperado al enviar. Por favor, inténtelo de nuevo. Si el problema persiste, contacte con soporte.'
        this.showRefreshDialog = false
        this.refresh_message = 'El documento ha sido modificado. Por favor, recargue la página.'
        this.hasActiveContract = false
    }

    success_message(message){
        this.snackbar['text'] = message
        this.snackbar['color'] = 'success'
        this.snackbar['isVisible'] = true
    }

    error_message(message){
        this.snackbar['text'] = message
        this.snackbar['color'] = 'error'
        this.snackbar['isVisible'] = true
    }

    async ask_for_file(){
      this.excel_pop_up = true
      return new Promise((resolve,reject)=>{
            this.resolve_pop_up = resolve
        })
    }

    async delete_all_lines_dialog(){
        this.delete_all_lines_pop_up = true
        return new Promise((resolve,reject)=>{
            this.resolve_pop_up = resolve
        })
    }

    confirm_pop_up(){
        this.excel_pop_up = false
        this.delete_all_lines_pop_up = false
        this.resolve_pop_up(true)
    }

    cancel_pop_up(){
        this.excel_pop_up = false
        this.delete_all_lines_pop_up = false
        this.resolve_pop_up(false)
    }

    setLoading(loading){
        this.loading = loading
    }

    setLines(lines){
        console.log('setting lines')
        this.invoice.lines = [...lines]
    }

    setInvoice(invoice){
        invoice.compute()
        this.invoice = invoice
        this.setLines(invoice.lines)
        this.computeDownloadOptions()
    }

    computeDownloadOptions(){
        if (['budget', 'delivery_note', 'proforma'].includes(this.invoice.type)) {
            this.download_options = [
                {value: 'pdf', text: 'PDF'},
            ]
        }
    }

    setRectificativeInvoice(invoice){
        if (invoice){
            invoice.compute()
            this.rectificative_invoice = invoice
        }
    }

    resetLines(){
        console.log('resetting lines')
        this.invoice.lines=[...this.invoice.lines]
    }

    setRejectDialog(reject_dialog: boolean): void {
        this.reject_dialog = reject_dialog
    }

    setLoadingReject(loading: boolean): void {
        this.loading_reject = loading
    }

    setPaidDialog(paid_dialog: boolean): void {
        this.paid_dialog = paid_dialog
    }

    setLoadingPaid(loading: boolean): void {
        this.paid_loading = loading
    }

    setCustomers(customers: Party[]): void {
        this.customers = customers
    }

    setCustomer(customer:Party): void {
        this.invoice.customer = customer
    }

    setProducts(products:Product[]): void {
        this.products = products;
    }

    setErrorDialog(showErrorsDialog: boolean): void {
        this.showErrorsDialog = showErrorsDialog
    }

    setErrorDialogVerifactu(showErrorsDialog: boolean): void {
        this.showErrorsDialog = showErrorsDialog
    }

    setSequence(sequence: Sequence): void {
        this.selectedSequence = sequence
    }

    setSequences(sequences: Sequence[]): void {
        this.availableSequences = sequences
    }

    setConfiguration(configuration: Configuration, is_from_recurring_contract?:boolean): void {
        this.configuration = configuration
        if (is_from_recurring_contract) {
            let recurringSeq = configuration.sequences.filter(sequence => sequence.is_for_recurring_contracts)
            this.setSequences(recurringSeq)
            return
        }
        let filteredSequences = configuration.sequences.filter(sequence => !sequence.is_for_recurring_contracts)
        this.setSequences(filteredSequences)
    }

    setPaymentMeans(payment_means: string): void{
        if (!this.invoice.flag_payment_means_modified){
            this.invoice.payment_means = payment_means
        }
    }

    setPaymentInformation(payment_information: string): void{
        if (!this.invoice.flag_payment_information_modified){
            this.invoice.payment_information = payment_information
        }
    }

    setErrorExcelDialog(showErrorExcelDialog: boolean): void {
        this.showErrorExcelDialog = showErrorExcelDialog
    }

    setErrorSendDialog(showErrorSendDialog: boolean, message?: string): void {
        this.showErrorSendDialog = showErrorSendDialog
        if (message) {
            this.error_send_message = message
        }
    }

    setProductConfiguration(product_configuration: ProductConfiguration): void {
        this.product_configuration = product_configuration
    }

    setRefreshDialog(showRefreshDialog: boolean, message?: string): void {
        this.showRefreshDialog = showRefreshDialog
        if (message) {
            this.refresh_message = message
        }
    }

}